<div class="dropzone" appFileDrop (hovered)="toggleHover($event)" (dropped)="startUpload($event)" [class.hovering]="isHovering" *ngIf="showDropZone">
    <div class="file" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
            <h3>{{title}}</h3>
            <h6 class="stepper-title">({{'process.wayOfSigning.maximumFiles' | transloco}} {{maxFile}})</h6>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center">
            <button mat-stroked-button [disabled]="disabled" (click)="fileInput.click()">{{'process.wayOfSigning.selectBtn' | transloco}}</button>
            <input hidden type="file" (change)="startUpload($event.target.files)" [accept]="acceptedExtensions" [multiple]="multipleSelection" #fileInput>
        </div>
        <div>
            <h6 class="stepper-title">{{'process.wayOfSigning.selectAFileLbl' | transloco}} {{acceptedExtensions}}</h6>
        </div>
    </div>
</div>
<mat-list class="file-upload-list" *ngIf="files.length > 0">
    <h3 matSubheader>{{'process.wayOfSigning.selectedFiles' | transloco}}</h3>
    <mat-list-item *ngFor="let file of files; index as i" (click)="view(file)">
        <mat-icon matListItemIcon class="fa-lg" fontSet="fa" fontIcon="fa-paperclip"></mat-icon>
        <span matListItemTitle>{{file.name}}</span>
        <span matListItemLine>{{file.size | fileSize}}</span>
        <div *ngIf="canViewFile" class="sliding-actions view" fxlayout="row" fxlayoutgap="16px">
            <button mat-icon-button (click)="viewBigFile($event, file)" [title]="'common.see' | transloco">
                <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-eye"></mat-icon>
            </button>
        </div>
        <button matListItemMeta *ngIf="canRemove" mat-icon-button (click)="$event.stopPropagation(); remove(i)" [title]="'common.delete' | transloco">
            <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
        </button>
    </mat-list-item>
</mat-list>
